<div class="dialog-wrap cancel-dialog">
  <button type="button"
          (click)="close()"
          class="btn btn-close text-size-15">
    <craft-icon class="svg-icon"
                name="general--close-md"></craft-icon>
  </button>

  <h1 mat-dialog-title
      class="dialog-title">Cancel upload?</h1>

  <div mat-dialog-content=""
       class="dialog-content">
    <div class="dialog-desc">Upload is not complete.<br />
      Would you like to cancel the upload?</div>
  </div>

  <div mat-dialog-actions=""
       class="dialog-actions d-flex justify-end">
    <button class="btn btn-cancel dialog-btn"
            type="button"
            (click)="close()"
            mat-button="">Continue upload</button>
    <button class="btn btn-blue dialog-btn"
            type="button"
            (click)="done()"
            mat-button="">Cancel upload</button>
  </div>
</div>
